import { LayoutSettingSelectedEventData } from '@databases/analytics/src/types';
import React, { FunctionComponent } from 'react';

import DateFieldSetting from './DateFieldSetting';

export interface CalendarLayoutOptionsProps {
  contentId: string;
  source: LayoutSettingSelectedEventData['source'];
}

const CalendarLayoutOptions: FunctionComponent<CalendarLayoutOptionsProps> = ({
  contentId,
  source,
}) => {
  return <DateFieldSetting contentId={contentId} source={source} />;
};

export default CalendarLayoutOptions;
